import { generateRandomString } from 'flow/utils';

/**
 * A minimal implementation of a JSONP-requester.
 * For more on JSONP, see https://www.w3schools.com/js/js_json_jsonp.asp.
 * This implementation is inspired by
 * http://json.com/2013/12/16/send-jsonp-cross-domain-requests.html
 *
 * This is used in spokes.js instead of jQuery's method of making JSONP-requests.
 * https://api.jquery.com/jQuery.getJSON/
 *
 * @param {String} url
 * @param {function} callback
 */
export const makeJSONPRequest = (url, callback) => {
    const tagId = generateRandomString();
    const scriptEl = document.createElement('script');
    scriptEl.setAttribute('id', tagId);

    const jsonpCallback = 'callback_' + tagId;
    window[jsonpCallback] = (result) => {
        callback(result);
        const scriptEl = document.getElementById(tagId);
        document.body.removeChild(scriptEl);
        delete window[jsonpCallback];
    };

    scriptEl.onerror = () => {
        document.body.removeChild(scriptEl);
        delete window[jsonpCallback];
    };

    scriptEl.setAttribute('src', url + '&callback=' + jsonpCallback);
    // The script is executed when the element is mounted in the DOM
    document.body.appendChild(scriptEl);
};
